// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var EmailDetailsController = function ($scope, $routeParams, $window, Email, DownloadService) {
    $scope.email = Email.get({ id: $routeParams.emailId, detailed: true },
        function (email) {
            if (!email || !email.CustomerId)
                return;
            if (email.Attachments && email.Attachments.length > 0)
                $scope.documentName = email.Attachments[0].FileName;
        });

    $scope.back = function () {
        $window.history.back();
    };

    $scope.download = function (id, searchByName) {
        let downloadInfo = new DownloadService();
        downloadInfo.$get({ id: id, searchByName: searchByName },
            function () {
                window.location = downloadInfo.Url;
            });
    };
};

EmailDetailsController.$inject = ['$scope', '$routeParams', '$window', 'Email', 'DownloadService'];
